import * as React from 'react'

export const pagination = () => {
  return (
    <nav className="pagination">
      <div className="pagination__inner container container--m">
        <ul className="pagination__list">
          <li className="pagination__item pagination__item--prev">
            <button className="pagination__button pagination__button--prev" disabled>Previous</button>
          </li>
          <li>
            <ul>
              <li className="pagination__item pagination__item--pages pagination__item--current">
                <button className="pagination__link">1</button>
              </li>
              <li className="pagination__item pagination__item--pages">
                <button className="pagination__link">2</button>
              </li>
              <li className="pagination__item pagination__item--pages pagination__item--spacer">...</li>
              <li className="pagination__item">
                <button className="pagination__link">9</button>
              </li>
              <li className="pagination__item pagination__item--pages">
                <button className="pagination__link">10</button>
              </li>
            </ul>
          </li>
          <li className="pagination__item pagination__item--next">
            <button className="pagination__button pagination__button--next link--arrow">Next</button>
          </li>
        </ul>
      </div>
    </nav>
  )
}
